import ReactDOM from "react-dom/client";

import { AuthContextProvider } from "./context/AuthContext";
import { CoursesContextProvider } from "./context/CoursesContext";
import { UsersContextProvider } from "./context/UsersContext";

import App from "./App";
import "./index.css";
import "./responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <UsersContextProvider>
      <CoursesContextProvider>
        <App />
      </CoursesContextProvider>
    </UsersContextProvider>
  </AuthContextProvider>
);
